import clsx from 'clsx';
import React, { useMemo } from 'react';

type Props = {
  aspectRatio: number;
} & React.ImgHTMLAttributes<HTMLImageElement>;

export default function ResponsiveImage({
  aspectRatio = 1,
  className = '',
  ...props
}: Props) {
  const topPadding = useMemo(() => getPaddingTop(aspectRatio), [aspectRatio]);
  const containerStyling = clsx('relative w-full overflow-hidden', className);

  return (
    <div className={containerStyling} style={{ paddingTop: topPadding }}>
      <img
        {...props}
        className="w-full h-full top-0 left-0 absolute object-cover object-center"
      />
    </div>
  );
}

/// aspect ratio calculate
function getPaddingTop(aspectRatio: number): string {
  if (!aspectRatio) return '0';

  // const [width, height] = aspectRatio.split(':').map(Number);
  // if (!width || !height) return '0';

  const padding = (1 / aspectRatio) * 100;
  return `${Math.ceil(padding)}%`;
}
